// LEADERBOARD screen markup. The ranked list, the medal styling and the
// "where do I stand" strip are rendered by the controller (leaderboard.ts)
// into #lbBody. The hero banner styles live in leaderboard-hero.css.
import './leaderboard-hero.css';

export const leaderboardHTML = /* html */ `
<div id="screenLeaderboard" class="leaderboard-screen hidden">
  <button class="btn secondary back" id="lbBackBtn" type="button" style="width:auto;padding:10px 16px;">← Home</button>
  <div class="lbh-hero">
    <div class="lbh-rays" aria-hidden="true"></div>
    <div class="lbh-text">
      <div class="lbh-title">Leaderboard</div>
      <div class="lbh-sub" id="lbSub">The faithful, ranked by lifetime XP</div>
    </div>
    <!-- First-place medal: two wine ribbon straps folded into a V, hanging a
         gold "1" coin. The straps bleed past the top edge (the hero clips
         overflow) and their tips overlap the coin's top rim. -->
    <svg class="lbh-medal" viewBox="0 0 120 150" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id="lbhCoinG" cx="42%" cy="34%" r="78%">
          <stop offset="0%" stop-color="#FFD95A"/>
          <stop offset="55%" stop-color="#F5B914"/>
          <stop offset="100%" stop-color="#DE9F00"/>
        </radialGradient>
        <linearGradient id="lbhRibL" x1="0" y1="0" x2="0.6" y2="1">
          <stop offset="0%" stop-color="#8E3B46"/>
          <stop offset="100%" stop-color="#7C303B"/>
        </linearGradient>
        <linearGradient id="lbhRibR" x1="1" y1="0" x2="0.4" y2="1">
          <stop offset="0%" stop-color="#8E3B46"/>
          <stop offset="100%" stop-color="#6F2A34"/>
        </linearGradient>
      </defs>
      <g transform="rotate(7 60 75)">
        <!-- coin: darker rim, gradient face, inner ring, numeral, highlight -->
        <circle cx="60" cy="103" r="40" fill="#B87E00"/>
        <circle cx="60" cy="103" r="36.5" fill="url(#lbhCoinG)"/>
        <circle cx="60" cy="103" r="29" fill="none" stroke="#C88E06" stroke-width="2.5"/>
        <circle cx="60" cy="103" r="25.5" fill="none" stroke="rgba(255,255,255,0.28)" stroke-width="1"/>
        <text x="60" y="118" text-anchor="middle"
              font-family="var(--fontRound), ui-rounded, system-ui"
              font-weight="900" font-size="46" fill="#7A5A10">1</text>
        <path d="M37 91 A30 30 0 0 1 52 71" fill="none"
              stroke="rgba(255,255,255,0.55)" stroke-width="4" stroke-linecap="round"/>
        <!-- soft shadow the ribbon tips cast onto the coin's top edge -->
        <path d="M50 63 L75 62 L74 80 L52 80 Z" fill="rgba(0,0,0,0.16)"/>
        <!-- left strap (tucks under the right one) -->
        <path d="M24 -6 L50 -6 L73 66 L49 78 Z" fill="url(#lbhRibL)"/>
        <path d="M28 -6 L52.5 72" fill="none" stroke="#B25A66" stroke-width="2.5"/>
        <path d="M46.5 -6 L69 61" fill="none" stroke="#B25A66" stroke-width="2.5"/>
        <!-- right strap folds over the left; darker crease along its fold edge -->
        <path d="M70 -6 L96 -6 L71 78 L47 66 Z" fill="url(#lbhRibR)"/>
        <path d="M70 -6 L47 66" fill="none" stroke="#5E222B" stroke-width="2.5"/>
        <path d="M74 -6 L51.5 61" fill="none" stroke="#B25A66" stroke-width="2"/>
        <path d="M92.5 -6 L68.5 72" fill="none" stroke="#B25A66" stroke-width="2.5"/>
      </g>
    </svg>
  </div>
  <div id="lbBody" class="lb-body"></div>
</div>`;
